import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.padding.km6};
    border: ${theme.border.width.thinner} ${theme.border.style.solid}
      ${theme.color.border.neutral.default};
    border-radius: ${theme.border.radius.default};
  `}
`;

export const Section = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    fuel-reload {
      align-self: end;
      margin-bottom: ${theme.spacing.km1};
    }
  `}
`;

export const WrapperCallout = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.padding.km5};
  `}
`;
